//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconFileFilled(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16 16H8V18H16V16Z" fill="currentColor" /><path d="M16 12H8V14H16V12Z" fill="currentColor" /><path d="M20 6.59L15.41 2H4V22H20V10H18V20H6V4H14V8H20V6.59Z" fill="currentColor" /></svg>;
}
export default IconFileFilled;